import { WifiStandardEnum } from '@ubnt/link-core/enums';
import Dropdown from '@ubnt/ui-components/Dropdown/Dropdown';
import { DropdownOption, DropdownValue } from '@ubnt/ui-components/Dropdown/types';
import { memo, useCallback, useMemo } from 'react';

import {
  CUSTOM_CLIENT_WIFI_STANDARDS,
  isSupportedCustomClientWifiStandard,
  type CustomClientWifiStandard,
} from '@ubnt/wifi-calculator/device/customClients';

interface WifiStandardDropdownProps {
  value: ValuesOf<typeof WifiStandardEnum>;
  onChange: (newValue: CustomClientWifiStandard) => void;
}

const WifiStandardDropdownImpl = (props: WifiStandardDropdownProps) => {
  const { value, onChange: onChangeProp } = props;

  const options = useMemo(
    () =>
      CUSTOM_CLIENT_WIFI_STANDARDS.map((value) => ({ label: value, value })).sort((optionA, optionB) =>
        optionB.label.localeCompare(optionA.label)
      ),
    []
  );

  const onChange = useCallback(
    (_: DropdownOption, newValue: DropdownValue) => {
      if (isSupportedCustomClientWifiStandard(newValue)) {
        onChangeProp(newValue);
      }
    },
    [onChangeProp]
  );

  return (
    <Dropdown
      label="WiFi Standard"
      onChange={onChange}
      options={options}
      value={value}
      variant="secondary"
      width="100%"
    />
  );
};

const WifiStandardDropdown = memo(WifiStandardDropdownImpl);

export default WifiStandardDropdown;
